/* TODO: t() */
import { Component } from 'react';

export type Props = {
  render: (id: string) => ReactElement;
};

let count = 0;

class FormField extends Component<Props> {
  _id = 'form-field-' + getSalt() + '-' + (count += 1);

  render() {
    let { render } = this.props;
    return render(this._id);
  }
}

function getSalt() {
  return Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(36);
}

export default FormField;
